import React from 'react'
import s from './AdminTitle.module.scss'

const AdminTitle = ({title}) => {
  return <p className={s.title}>{title}</p>
}

export default AdminTitle
